import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { get, post, put, remove } from "../Services/http";
import { translate } from "../Services/translation";

export default function DatePickerContainer(props) {
    const { onDetailsChange, customerDetails } = props;

    const getDeliveryDay = (date) => {
        const day = date.getDay();
        return day != 0 && day != 6;
    };

    const selectDate = (date) => {
        post("/api/customer/setdate", date).then((result) => {
            onDetailsChange("customerDetails", "requestedDeliveryDate", true);
        });
    };

    const AddDays = (includeToday) => {
        let date = new Date();
        var result = new Date(date);
        result.setDate(result.getDate() + (includeToday ? 0 : 1));
        return result;
    };

    const getStartDate = () => {
        var date = new Date();

        switch(date.getDay()){
            case 5: 
                date.setDate(date.getDate() + 3);
                break;
            case 6:
                date.setDate(date.getDate() + 2);
                break;
            default:
                date.setDate(date.getDate() + 1);
                break;
        }

        selectDate(date);
        return date;
    }
    const keyboardHandling = (e) => {
        e.preventDefault();
        return false;
    }

    const [startDate, setStartDate] = useState(getStartDate);

    return (
        <div className="checkout__form-container">
            <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                onSelect={(date) => selectDate(date)}
                minDate={AddDays(false)}
                filterDate={getDeliveryDay}
                disabledKeyboardNavigation
                onKeyDown={(e) => keyboardHandling(e)}
            />
            <span>{translate("datepicker.date")}</span>
        </div>
    );
}
